export const DASHBOARD_PORTALS = ["club", "camp"];
export const DEFAULT_DASHBOARD_PORTAL = "club";

export function normalizeDashboardPortal(value) {
  const portal = String(value || "").trim().toLowerCase();
  return DASHBOARD_PORTALS.includes(portal) ? portal : null;
}

export function getDashboardPath(portal, suffix = "") {
  const normalized = normalizeDashboardPortal(portal) || DEFAULT_DASHBOARD_PORTAL;
  const nextSuffix = String(suffix || "").trim();
  if (!nextSuffix) return `/dashboard/${normalized}`;
  return `/dashboard/${normalized}/${nextSuffix.replace(/^\/+/, "")}`;
}

export function getDashboardPortalLabel(portal) {
  return portal === "camp" ? "Camp" : "Club";
}
